export default function CommunityImpact() {
  const values = [
    { icon: 'ri-team-line', title: 'Teamwork', color: 'text-purple-600' },
    { icon: 'ri-shield-star-line', title: 'Discipline', color: 'text-yellow-600' },
    { icon: 'ri-trophy-line', title: 'Leadership', color: 'text-purple-600' },
    { icon: 'ri-community-line', title: 'Community Pride', color: 'text-yellow-600' }
  ];

  const fundingAreas = [
    { icon: 'ri-football-line', text: 'Equipment' },
    { icon: 'ri-user-star-line', text: 'Gameday Officials' },
    { icon: 'ri-landscape-line', text: 'Field Rental/CYFA Dues' },
    { icon: 'ri-shirt-line', text: 'Gameday Jerseys' },
    { icon: 'ri-settings-3-line', text: 'League Operations' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Why Businesses <span className="text-purple-700">Sponsor CYFA</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Youth Football Teaches Life Skills
            </h3>
            
            <div className="grid grid-cols-2 gap-6">
              {values.map((value, index) => (
                <div key={index} className="flex flex-col items-center text-center p-6 bg-white rounded-xl shadow-lg">
                  <div className={`w-16 h-16 flex items-center justify-center mb-4 ${value.color}`}>
                    <i className={`${value.icon} text-5xl`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-gray-900">{value.title}</h4>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full h-[500px]">
            <img
              src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/fd02484104d3a13d5c72fe4fbee90fb3.png"
              alt="Youth Football Training"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>

        <div className="bg-purple-900 rounded-3xl p-12 text-white">
          <h3 className="text-3xl font-bold mb-8 text-center">
            Your Sponsorship Helps Fund
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            {fundingAreas.map((area, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="w-20 h-20 flex items-center justify-center mb-4 bg-yellow-400 rounded-full">
                  <i className={`${area.icon} text-4xl text-purple-900`}></i>
                </div>
                <p className="text-lg font-bold">{area.text}</p>
              </div>
            ))}
          </div>

          <p className="text-center text-xl mt-12 font-medium leading-relaxed max-w-4xl mx-auto">
            Every dollar you invest goes directly toward creating a safe, competitive, and enriching environment where local kids can grow, learn, and thrive through the sport of football.
          </p>
        </div>
      </div>
    </section>
  );
}